var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-section",class:{ 'bottom-line': _vm.bottomLine }},[_c('div',{staticClass:"base-section-title"},[_c('span',{staticClass:"v-line"},[_vm._v("|")]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }